var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name"},[_c('div',{staticClass:"name-text"},[_c('core-gamename',{staticClass:"name-text-link",attrs:{"game":_vm.item.game,"id":_vm.item.id}})],1),_c('app-tags',{staticClass:"name-tags",attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }